export const MIN_INLINE_SHARE_THUMBNAIL_WIDTH = 399;
export const DEFAULT_WIDGET_HEIGHT = 250;
export const DEFAULT_WIDGET_WIDTH = 320;
export const GRID_HEADER_HEIGHT = 40;
export const GRID_VIDEO_HEIGHT = 220;
export const GRID_VIDEO_MARGIN_BOTTOM = 2;
export const GRID_LOAD_MORE_BUTTON_HEIGHT = 66;
